export default {
    path: '/outsource',
    name: 'Outsource',
    component: () => import('@/layout/index.vue'),
    // redirect: {
    //     name: "EquipmentMasterData"
    // },
    meta: {
        title: '外协管理',
        icon: 'iconfont icon-chaxunbaobiao',
        role: 'BACK_MENU6'
    },
    children: [
        {
            path: '/Outsource',
            name: 'Outsource',
            meta: {
                title: 'RET外协',
                icon: 'el-icon-menu',
                role: 'BACK_MENU6_M1'
            },
            component: () => import('@/views/RawMaterialWarehouse/Outsource.vue'),
        },
        {
            path: '/ProductionCallWx',
            name: 'ProductionCallWx',
            meta: {
                title: '仓库外协',
                icon: 'el-icon-menu',
                role: 'BACK_MENU6_M6'
            },
            component: () => import('@/views/Production/ProductionCallWx.vue'),
        },
        {
            path: '/OutsourcePick',
            name: 'OutsourcePick',
            meta: {
                title: '外协发货',
                icon: 'el-icon-menu',
                role: 'BACK_MENU6_M2'
            },
            component: () => import('@/views/RawMaterialWarehouse/OutsourcePick.vue'),
        },
        {
            path: '/MaterialTransferOut',
            name: 'MaterialTransferOut',
            meta: {
                title: '物料移库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU6_M3'
            },
            component: () => import('@/views/RawMaterialWarehouse/MaterialTransferOut.vue'),
        },
        {
            path: '/supplierOutsource',
            name: 'SupplierOutsource',
            component: () => import('@/views/vendors/supplierOutsource.vue'),
            meta: {
                title: '供应商外协',
                role: 'BACK_MENU6_M4'
            }
        },
        {
            path: '/supplierOutsourceDetails',
            name: 'SupplierOutsourceDetails',
            component: () => import('@/views/vendors/supplierOutsourceDetails.vue'),
            meta: {
                title: '外协发货记录',
                role: 'BACK_MENU6_M7'
            }
        },
        {
            path: '/supplierOutsourceDetailsQuan',
            name: 'SupplierOutsourceDetailsQuan',
            component: () => import('@/views/vendors/supplierOutsourceDetailsQuan.vue'),
            meta: {
                title: '外协详情',
                role: 'BACK_MENU6_M7'
            }
        },
        {
            path: '/qualityInspectionEntryOutsource',
            name: 'QualityInspectionEntryOutsource',
            meta: {
                title: '质检录入',
                icon: 'el-icon-menu',
                role: 'BACK_MENU6_M5'
            },
            component: () => import('@/views/Quality/QualityInspectionEntryOutsource.vue'),
        },
    ],
}